.lightbox {
  --detailsShown: 0;
  --detailsWidth: 23.75rem;
  --toolbarHeight: 3.125rem;
}

.lightbox.details-shown {
  --detailsShown: 1;
}

.lightbox video {
  width: 100%;
  height: 100%;
}

.toolbar {
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: var(--toolbarHeight);
  padding: 0 1rem;
}

.toolbar-group {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}

.file-name {
  color: var(--white);
  font-size: var(--fs-lg);
  font-weight: 500;
}

.nav-button {
  position: absolute;
  top: 50%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background-color: var(--white);
  transform: translateY(-50%);
  transition: right 0.2s ease;
  cursor: pointer;
}

.nav-button.prev {
  left: 1rem;
}

.nav-button.next {
  right: calc(1rem + var(--detailsShown) * var(--detailsWidth));
}

.details {
  position: absolute;
  top: 0;
  right: 0;
  box-sizing: border-box;
  width: var(--detailsWidth);
  height: 100%;
  overflow-y: auto;
  background-color: var(--dark-gray);
  margin-right: calc((var(--detailsShown) - 1) * var(--detailsWidth));
  transition: margin-right 0.2s ease;
}

.details-header {
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: var(--toolbarHeight);
  padding-left: 1rem;
  border-bottom: 1px solid var(--dim);
}

.details-title {
  color: var(--white);
  font-size: var(--fs-lg);
  font-weight: 500;
}

.details-content {
  display: flex;
  flex-flow: column nowrap;
  padding: 1.25rem;
}

.detail-row {
  display: flex;
  flex-flow: row nowrap;
  padding-bottom: 1rem;
  font-size: var(--fs-md);
}

.detail-row.stacked {
  flex-flow: column nowrap;
}

.detail-label {
  width: 30%;
  color: var(--gray);
  white-space: nowrap;
}

.detail-value {
  width: 70%;
  color: var(--white);
  overflow-wrap: break-word;
}

.detail-row.stacked .detail-label {
  width: 100%;
  padding-bottom: 0.25rem;
}

.detail-row.stacked .detail-value {
  width: 100%;
}

.editable-value {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  line-height: var(--lh-xxl);
}

.edit-field {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5rem;
}

.edit-error {
  color: var(--error);
  font-size: var(--fs-sm);
  line-height: var(--lh-xs);
}

.edit-actions {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
}

.edit-action {
  min-width: 3rem;
  padding: 0;
  border: 0;
  background: none;
  font-family: inherit;
  font-size: var(--fs-md);
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
}

.edit-action.cancel {
  color: var(--gray);
  margin-right: 1rem;
}

.edit-action.save {
  color: var(--white);
}

.edit-action.cancel:disabled,
.edit-action.save:disabled {
  color: var(--dim);
  cursor: default;
}
